import {
  SegmentedControl,
  type SegmentedControlOption,
} from '@/pages/Schedule/components';
import type { SubscriptionType } from '../types';

type Props = {
  value: SubscriptionType;
  ariaLabel: string;
  monthlyLabel: string;
  annualLabel: string;
  onChange: (value: SubscriptionType) => void;
};

// Monthly/Annual switcher shared by every surface that quotes a price, so the
// control (and the option order) can't drift between them.
export const BillingIntervalToggle = ({
  value,
  ariaLabel,
  monthlyLabel,
  annualLabel,
  onChange,
}: Props) => {
  const options: SegmentedControlOption<SubscriptionType>[] = [
    { label: monthlyLabel, value: 'monthly' },
    { label: annualLabel, value: 'yearly' },
  ];

  return (
    <SegmentedControl
      aria-label={ariaLabel}
      bg="gray.100"
      options={options}
      value={value}
      onChange={onChange}
    />
  );
};
